<template>
  <div class='h100-40 h-scroll'>
    <ejs-grid ref="dataOfPmNoRealTaskList" :dataSource="dataForPmNoRealTaskList" :rowSelected='rowSelectedOfPmNoRealTaskList' :rowDeselected='rowDeselectedOfPmNoRealTaskList'>
      <e-columns>
<!--        <e-column field='taskId' :headerText='$t("Pm.taskID")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>-->
        <e-column field='taskName' :headerText='$t("Pm.taskName")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskDepict' :headerText='$t("Pm.taskDescription")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neType' :headerText='$t("Pm.resourceType")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neId' :headerText='$t("Pm.resourceId")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='sampleTime' :headerText='$t("Pm.collectCycle")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="cycleFormatter"></e-column>
        <e-column field='reportTime' :headerText='$t("Pm.reportCycle")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="cycleFormatter"></e-column>
        <e-column field='startTime' :headerText='$t("Pm.start_time")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="dataFormatterFromTimeStramp"></e-column>
        <e-column field='endTime' :headerText='$t("Pm.end_time")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="dataFormatterFromTimeStramp"></e-column>
        <e-column field='startHour' :headerText='$t("Pm.startTimeFrame")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="hourFormatter"></e-column>
        <e-column field='endHour' :headerText='$t("Pm.endTimeFrame")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="hourFormatter"></e-column>
        <e-column field='week' :headerText='$t("Pm.weekPlan")' textAlign='Center' width='6%' clipMode='EllipsisWithTooltip' :formatter="weekPlanFormatter"></e-column>
        <e-column field='day' :headerText='$t("Pm.monthPlan")' textAlign='Center' width='6%' clipMode='EllipsisWithTooltip' :formatter="dayPlanFormatter"></e-column>
        <e-column field='taskConsistentStatus' :headerText='$t("Pm.consistentState")' textAlign='Center' width='8%' clipMode='EllipsisWithTooltip' :formatter="taskConsistentStatusFormatter"></e-column>
        <e-column field='taskStatus' :headerText='$t("Pm.taskState")' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter="taskStatusFormatter"></e-column>
        <e-column field='taskSyncTime' :headerText='$t("Pm.syncTime")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="dataFormatterFromTimeStramp"></e-column>
        <e-column field='taskResetBegTime' :headerText='$t("Pm.hangupTime")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="dataFormatterFromTimeStramp"></e-column>
        <e-column field='taskResetEndTime' :headerText='$t("Pm.activeTime")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="dataFormatterFromTimeStramp"></e-column>
        <e-column field='taskEditPeople' :headerText='$t("Pm.editor")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskEditTime' :headerText='$t("Pm.editTime")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="dataFormatterFromTimeStramp"></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref="pagerForPmNoRealTaskList" @click="getTaskListOfPmNoReal" :currentPage='page.currentPage' :pageCount='page.pageCount' :pageSize='page.pageSize' :totalRecordsCount='page.totalRecordsCount'></ejs-pager>
  </div>
</template>

<script>
  import {ContextMenu, Reorder, Resize} from "@syncfusion/ej2-vue-grids";
  import DateUtil from '../../../util/DateUtil.js';
  import {PmEventBus} from "../../../util/PmEventBus";

  export default {
  name: 'PmNoRealTaskRightListContent',
  props: [
    'queryParamsForResourceTreeClick',
  ],
  data() {
    return {
      dataForPmNoRealTaskList: [],
      sampleTime: null,
      reportTime: null,
      taskStatusForQuery: null,
      page: {
        currentPage: 1,
        pageSize: 25,
        totalRecordsCount: 0,
        pageCount: 10
      },
      rowDataOfPmNoRealTaskList: '',
      meterTimePeriods: new Map()
        .set(300000, this.$t('Pm.fiveMinutes'))
        .set(900000, this.$t('Pm.fifteenMinutes'))
        .set(1800000, this.$t('Pm.thirtyMinutes'))
        .set(3600000, this.$t('Pm.oneHour'))
        .set(86400000, this.$t('Pm.oneDay')),
      taskConsistentStatus: new Map()
        .set(0, this.$t('Pm.inconsistent'))
        .set(1, this.$t('Pm.consistent')),
      taskStatus: new Map()
        .set(0, this.$t('Pm.hangup'))
        .set(1, this.$t('Pm.active'))
        .set(2, this.$t('Pm.failure')),
    };
  },
  methods: {
    taskStatusFormatter(column,data){
      let color = '';
      switch (data[column.field]) {
        case 0:
          color = 'red';
          break;
        case 1:
          color = 'green';
          break;
        case 2:
          color = 'gray';
          break;
        default:
          break;
      }
      return `<span style='background-color:${color};font-size: 12px;display: inline-block;width: 55px;height: 22px;color: #fff;line-height: 22px;' >${this.taskStatus.get(data[column.field])}</span>`;
    },
    taskConsistentStatusFormatter(column,data){
      return this.taskConsistentStatus.get(data[column.field]);
    },
    weekPlanFormatter(column,data) {
      let weekPlan = data[column.field];
      console.log('weekPlan',weekPlan);
      if (weekPlan == null) {
          return '';
      }
      let weekDayList = weekPlan.split(',');
      weekDayList.sort(function(a,b){
        let c = parseInt(a);
        if(c == 0){
          c = 7
        }
        let d = parseInt(b);
        if(d == 0){
          d =7;
        }
        return  c - d;
      })

      for(let i = 0; i < weekDayList.length; i++) {
        let day =  weekDayList[i];
        switch(day){
          case '0':
            weekDayList[i] = this.$t('Pm.sunday');
            break;
          case '1':
            weekDayList[i] = this.$t('Pm.monday');
            break;
          case '2':
            weekDayList[i] = this.$t('Pm.tuesday');
            break;
          case '3':
            weekDayList[i] = this.$t('Pm.wednesday');
            break;
          case '4':
            weekDayList[i] = this.$t('Pm.thursday');
            break;
          case '5':
            weekDayList[i] = this.$t('Pm.friday');
            break;
          case '6':
            weekDayList[i] = this.$t('Pm.saturday');
            break;
          default:
            break;
        }
      }

      return weekDayList.join();
    },
    dayPlanFormatter(column,data){
      let dayPlan = data[column.field];

      if(dayPlan == null){
        return '';
      }
      let dayDayList = dayPlan.split(',');
      dayDayList.sort(function(a,b){
        return parseInt(a) - parseInt(b);
      })

      for(let i = 0; i < dayDayList.length; i++) {
        dayDayList[i] = dayDayList[i];
      }
      return dayDayList.join();
    },
    hourFormatter(column,data){
      return data[column.field] == null ? '' : data[column.field] + this.$t('Pm.oClock');
    },
    dataFormatterFromTimeStramp(column,data){
      if(data[column.field] == null){
        return null;
      } else {
        const date = new Date(data[column.field] * 1000);
        return DateUtil.getDateString(date);
      }
    },
    cycleFormatter(column,data){
      return this.meterTimePeriods.get(data[column.field]);
    },
    rowSelectedOfPmNoRealTaskList(msg) {
      this.rowDataOfPmNoRealTaskList = msg.data;
      this.$emit('taskStatusChange', msg.data.taskStatus);
    },
    rowDeselectedOfPmNoRealTaskList() {
      this.rowDataOfPmNoRealTaskList = '';
      this.$emit('taskStatusChange', 3);
    },
    async getTaskListOfPmNoReal(queryParamsForResourceTreeClick) {
      const This = this;
      This.page.currentPage = This.$refs.pagerForPmNoRealTaskList.ej2Instances.currentPage;
      let neTypeCode = '';
      let neId = '';
      if(queryParamsForResourceTreeClick){
        neTypeCode = queryParamsForResourceTreeClick.neTypeCode ? queryParamsForResourceTreeClick.neTypeCode : '';
        neId = queryParamsForResourceTreeClick.neId ? queryParamsForResourceTreeClick.neId : '';
      }
      this.$axios.post('/lte/ems/pm/noReal/task/getTaskListDataByResource.html', {
        neTypeCode: neTypeCode,
        neId: neId,
        sampleTime: this.sampleTime,
        reportTime: this.reportTime,
        taskStatus: this.taskStatusForQuery,
        page: {
          pageNo: This.page.currentPage,
          pageSize: This.page.pageSize
        }
      }).then((response) => {
        const result = response.data.resultVal;
        This.page.totalRecordsCount = result.totalCount;
        This.page.currentPage = result.pageNo;
        This.dataForPmNoRealTaskList = result.result;
      });
    }
  },
  mounted() {
    this.$loading.showLoadding(this.$t('System.loading'));
    this.getTaskListOfPmNoReal();
    this.$loading.hideLoadding();

    PmEventBus.$on('sampleTimeChange',(args) => {
      const cycle = args.value;
      if(cycle == 0){
        this.sampleTime = null;
      }else{
        this.sampleTime = cycle + '';
      }
      this.getTaskListOfPmNoReal(this.queryParamsForResourceTreeClick);
    })

    PmEventBus.$on('reportTimeChange',(args) => {
      const cycle = args.value;
      if(cycle == 0){
        this.reportTime = null;
      }else{
        this.reportTime = cycle + '';
      }
      this.getTaskListOfPmNoReal(this.queryParamsForResourceTreeClick);
    })

    PmEventBus.$on('taskStatusChange',(args) => {

      const taskStatus = args.value;
      if(taskStatus == 3){
        this.taskStatusForQuery = null;
      }else{
        this.taskStatusForQuery = taskStatus;
      }
      this.getTaskListOfPmNoReal(this.queryParamsForResourceTreeClick);
    })
  },
  provide: {
    grid: [Reorder, Resize, ContextMenu]
  },
  watch: {
    queryParamsForResourceTreeClick(queryParamsForResourceTreeClick) {
      this.getTaskListOfPmNoReal(queryParamsForResourceTreeClick);
    }
  }
};
</script>

<style>

</style>
